import request from "root/js/request";

export const getRegionClusters = async () => {
  const response = await request({
    url: `analytics/wh_supply/region-clusters/`,
    method: "get",
  });
  return response.data;
};
